import { Component, OnInit } from '@angular/core';
import { locale } from 'devextreme/localization';
import 'devextreme-intl';

import { DataStoreService } from '../../core/services/data-store/data-store.service';

@Component({
  selector: 'baf-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {
  isValidState = true;

  constructor(storeService: DataStoreService) {
    locale(navigator.language);

    storeService.getErrorId().subscribe(eId => {
      this.isValidState = eId === 0;
    });
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/layout/layout.component.ts